// Contact / WhatsApp / media constants for TINTA

export const WHATSAPP_NUMBER = "5491158214406"; // Argentina international format (+54 9 11 5821 4406)
export const WHATSAPP_URL = (message = "") =>
  `https://wa.me/${WHATSAPP_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export const INSTAGRAM_URL = "https://www.instagram.com/tinta.ba/";
export const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/place/Tinta+restaurante+%26+bar/@-34.5836,-58.4301,17z";

// Embedded map (Jose A. Cabrera 5621, Palermo)
export const GOOGLE_MAPS_EMBED =
  "https://www.google.com/maps?q=Jos%C3%A9+A.+Cabrera+5621,+Palermo,+Buenos+Aires&output=embed";

// Real photos from @tinta.ba Instagram (visually verified)
const PHOTOS = {
  interior_dining:
    // g4hijekr — restaurant interior with blinds, candles, tables, Chesterfield seating
    "https://customer-assets.emergentagent.com/job_fusion-tinta-stage/artifacts/g4hijekr_SaveClip.App_671254241_18228654310312977_4632041957088177415_n.jpg",
  lounge_velvet:
    // k3tdregx — lounge with orange velvet sofa and bookshelves
    "https://customer-assets.emergentagent.com/job_fusion-tinta-stage/artifacts/k3tdregx_SaveClip.App_682384192_18230499985312977_8587756305437016592_n.jpg",
  plate_main:
    // 40jao6uo — plated main dish (meat with greens, sprouts, knife cutting)
    "https://customer-assets.emergentagent.com/job_fusion-tinta-stage/artifacts/40jao6uo_SaveClip.App_683489306_18230244181312977_6755835052114022948_n.jpg",
  canelon_pan:
    // 965k0rzu — canelón/stuffed dish in cast iron pan with tomato sauce
    "https://customer-assets.emergentagent.com/job_fusion-tinta-stage/artifacts/965k0rzu_SaveClip.App_683795490_18230244172312977_868794043392967989_n.jpg",
  ravioles_wine:
    // tko9blyt — ravioles with red sauce + cheese + wine glass
    "https://customer-assets.emergentagent.com/job_fusion-tinta-stage/artifacts/tko9blyt_SaveClip.App_683688501_18230244163312977_6806146786112986282_n.jpg",
  // Fallback Unsplash for items we don't have a real photo of yet
  sushi:
    "https://images.unsplash.com/photo-1761315414066-007d3ee09e5d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxnb3VybWV0JTIwc3VzaGklMjBwbGF0ZSUyMGRhcmt8ZW58MHx8fHwxNzc4MDIzMjEzfDA&ixlib=rb-4.1.0&q=85",
  cocktail_1:
    "https://images.unsplash.com/photo-1717462797650-680b8a266c96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxzaWduYXR1cmUlMjBjb2NrdGFpbCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3ODAyMzIxM3ww&ixlib=rb-4.1.0&q=85",
  cocktail_2:
    "https://images.unsplash.com/photo-1626688402251-98aa6e9b8999?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxzaWduYXR1cmUlMjBjb2NrdGFpbCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3ODAyMzIxM3ww&ixlib=rb-4.1.0&q=85",
  dessert:
    "https://images.unsplash.com/photo-1762631176801-76ceba0814ab?fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0",
};

// Public MEDIA contract (consumed by components)
export const MEDIA = {
  hero_interior: PHOTOS.interior_dining, // real restaurant interior for Hero
  gallery_interior: PHOTOS.lounge_velvet, // velvet lounge for About section
  gallery_plate_main: PHOTOS.plate_main,
  gallery_canelon: PHOTOS.canelon_pan,
  gallery_ravioles: PHOTOS.ravioles_wine,
  menu_cocktail_1: PHOTOS.cocktail_1,
  menu_cocktail_2: PHOTOS.cocktail_2,
};

// Explicit per-menu-item photos (order matches t.menu.items)
export const MENU_IMAGES = [
  PHOTOS.sushi,         // 0 Sushi Miami Hot (Unsplash)
  PHOTOS.plate_main,    // 1 Lomo con papas noisette (real)
  PHOTOS.ravioles_wine, // 2 Ravioles de ternera (real)
  PHOTOS.cocktail_1,    // 3 Fake Watermelon (Unsplash)
  PHOTOS.cocktail_2,    // 4 Sangría (Unsplash)
  PHOTOS.dessert,       // 5 Volcán de chocolate (Unsplash)
];

export { PHOTOS };
